import getTotalRemainingSeconds from './getTotalRemainingSeconds';

export default (endTime: number, date: Date): number => {
  // Math.floor instead of Math.round to prevent minutes changing when seconds = 30
  return Math.floor((getTotalRemainingSeconds(endTime, date) / 60) % 60);
};
